import React, { Component } from 'react'
import moment from 'moment';
import '../css/App.css'
import {convertDateFormat, convertTime} from '../utils/helper'
import AlignIcon from 'react-icons/lib/fa/align-justify'

class ERHeader extends Component{

    toggleFilters = () => {
        if( document.getElementById('filternav')){
            const element = document.getElementById('filternav')
            let visibility = element.style.display 
        
            if(visibility == ''){
                element.style.display = 'block'
            }else{
                element.style.display = ''
            }
        }
        
        if(document.getElementById('partyfilter')){
            const elem = document.getElementById('partyfilter')
            let visibility_party = elem.style.display 
            
            if(visibility_party == ''){
               elem.style.display = 'block'
            }else{
               elem.style.display = ''
            }
        }

    }

    render(){
        const {election, resultType, lastUpdate, precinctCount, totalPrecincts, isLive, electionDate} = this.props
        
        let isShowPrecinctsCounted = true;
        if (electionDate && moment(electionDate).format('YYYY') >= 2024) {
            isShowPrecinctsCounted = false;
        }
        return(
            <React.Fragment>
                
                <div className="col-sm-9 col-xs-12 navHeader">
                    <h3 style={{fontWeight:'bold',color:'white',marginBottom:'10px'}}>{(election ? election: "" )+ (resultType ? " - "+resultType : "") }</h3>
                    <div>
                        {isLive && <h4 className='livediv' style={{display:'inline-block',marginRight:'40px', border:'1.5px solid white', borderRadius:'5.5px', padding:'4px 8px', marginBottom:'0px'}}> 
                            <div id='liveicon' className="animated infinite flash" style={{ height: '12px',width: '12px',backgroundColor: 'red',borderRadius: '50%',display: 'inline-block', marginRight:'8px'}}></div>
                            Live
                        </h4>}
                        <div style={{display: 'inline-block'}}>
                            <h5 id='elecdate'>Election Date: {electionDate ? convertDateFormat(electionDate) : ''}</h5>
                            <p>Last Updated: {lastUpdate ? (convertDateFormat(lastUpdate)+' '+convertTime(lastUpdate)): ''} </p>
                            
                        </div>
                    </div>
                </div>
                <div className="col-sm-3 col-xs-12 navCount row" >
                    {isShowPrecinctsCounted && (
                        <div className='col-6  col-md-12' >
                            <span id='count_num'>{precinctCount}</span>
                            <span>/ {totalPrecincts}</span>
                            <p id='count'>Precincts Counted</p>
                        </div>
                    )}
                    <div className='col-xs-6 ' id='filter-collapse'>
                        <a onClick={this.toggleFilters} className='btn btn-secondary'>Filters <AlignIcon /></a>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default ERHeader




// WEBPACK FOOTER //
// ./src/components/ERHeader.js